import React from 'react';

const FoundationContact = () => {
  return (
    <section id="contact" className="py-16 md:py-24 px-4 md:px-8 bg-yellow-50 text-gray-800 relative overflow-hidden">
      <img
        src="/img8.jpg"
        alt="Textura cultural afrocolombiana"
        className="absolute inset-0 w-full h-full object-cover opacity-10"
      />
      <div className="relative z-10 max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 text-green-800">
          Contáctanos
        </h2>

        <div className="bg-white p-6 md:p-10 rounded-3xl shadow-2xl border border-gray-200 flex flex-col md:flex-row gap-8">
          {/* Botones de contacto */}
          <div className="md:w-1/2 flex flex-col justify-center items-center gap-6">
            <h3 className="text-2xl font-semibold text-gray-700">💬 ¡Hablemos!</h3>

            <a
              href="https://wa.me/573005448631" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg text-lg font-medium shadow-lg transition duration-300 w-full text-center"
            >
              🟢 Escribir por WhatsApp
            </a>

            <a
              href="mailto:corpdesolcaribe@hotmail.com"
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-lg text-lg font-medium shadow-lg transition duration-300 w-full text-center"
            >
              ✉️ Enviar Correo
            </a>
          </div>

          {/* Información de contacto */}
          <div className="md:w-1/2 flex flex-col justify-center">
            <h3 className="text-2xl font-semibold text-gray-700 mb-4">ℹ️ Nuestra Información</h3>
            <div className="space-y-4 text-lg">
              <p className="flex items-center">
                <svg className="w-6 h-6 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                CL 12 2 38 SEGUNDO PISO, Ciénaga, Magdalena
              </p>
              <p className="flex items-center">
                <svg className="w-6 h-6 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.774a11.037 11.037 0 006.103 6.103l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                +57 302 658 1916
              </p>
              <p className="flex items-center">
                <svg className="w-6 h-6 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.774a11.037 11.037 0 006.103 6.103l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                +57 300 544 8631
              </p>
              <p className="flex items-center">
                <svg className="w-6 h-6 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.774a11.037 11.037 0 006.103 6.103l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                +57 300 201 1681
              </p>
              <p className="flex items-center">
                <svg className="w-6 h-6 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                corpdesolcaribe@hotmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundationContact;
